<template>

  <div>
<!--    {{ isWx ? '微信' : '1' }}-->
<!--    {{ isAli ? '支付宝' : '2' }}-->

    <div :class=" type == 0 ? 'top-area' : ''">
<!--      <div class="header">-->
<!--        辽宁-->
<!--      </div>-->

      <el-alert
          v-if="type == 0"
          title="目前仅支持辽宁朝阳地区使用"
          :closable="false"
          type="error">
      </el-alert>

      <div v-if="type == 0" style="margin-top: 20vh">

        <div class="butt" @click="toAuth()">
          <div class="box">
            物理印章备案申请
          </div>
        </div>

        <!--      <img class="butt mt20" src="@/assets/h5-orderList.png" alt />-->

        <div class="butt mt20" @click="type = 1">
          <div class="box" style="background: linear-gradient(to left, #007bff, #4ca1f1)">备案申请查询</div>
        </div>

      </div>

      <div v-if="type == 1">
        <div class="single-apply-area">
          <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="150px"
              label-position="left"
              v-loading="loading"
          >

            <el-form-item label="经办人信息" style="background-color: #fafafa" class="mt20" />

            <el-form-item prop="operatorName" label="经办人姓名" class="input-item">
              <el-input
                  v-model="ruleForm.operatorName"
                  placeholder="请输入经办人姓名"
              ></el-input>
            </el-form-item>

            <el-form-item prop="operatorId" label="经办人身份证号" class="input-item">
              <el-input
                  v-model="ruleForm.operatorId"
                  placeholder="请输入经办人身份证号"
              ></el-input>
            </el-form-item>
<!--         @input="handleInputNumber('operatorPhone')"   -->
            <el-form-item prop="operatorPhone" label="手机号码" class="input-item">
              <el-input
                  type="number"
                  v-model="ruleForm.operatorPhone"
                  :maxlength="11"
                  placeholder="请输入手机号码"
              ></el-input>
            </el-form-item>

            <div class="bottom-box">
              <el-button type="primary" style="width: 40%" @click="type = 0">返回</el-button>
              <el-button type="primary" style="width: 40%" @click="getData()">查询</el-button>
            </div>

          </el-form>
        </div>
      </div>

      <div v-if="type == 2">
        <div v-if="tableData.length > 0">
          <el-card class="box-card" style="margin: 20px 5%;text-align: left" v-for="(item , index) in tableData" :key="index">
            <el-descriptions title="" :column="1">
              <el-descriptions-item label="订单编号">{{ item.tradeNo ? item.tradeNo : '' }}</el-descriptions-item>
              <el-descriptions-item label="企业名称">{{ item.orgName ? item.orgName : '' }}</el-descriptions-item>
              <el-descriptions-item label="刻企名称">{{ item.makeOrgName ? item.makeOrgName : '' }}</el-descriptions-item>
              <el-descriptions-item label="订单状态">
                <div style="width: 100%;display: flex;justify-content: space-between">
                  <div>
                    <el-tag v-if="item.status == 1" size="small">已付款</el-tag>
                    <el-tag v-if="item.status == 0" size="small" type="warning">未付款</el-tag>
                    <el-tag v-if="item.status == -1" size="small" type="danger">备案失败</el-tag>
                  </div>

                  <div>
                    <div v-if="item.status == 1 && !item.expandState" @click="getDetail(item.tradeNo , index)" style="color: #409eff">展开 <i class="el-icon-arrow-down"></i></div>
                    <div v-if="item.status == 1 && item.expandState" @click="withdraw(index)" style="color: #409eff">收回 <i class="el-icon-arrow-up"></i></div>
                  </div>
                </div>

                <!--            <el-tag v-if="item.status == -1" size="small"></el-tag>-->
              </el-descriptions-item>
            </el-descriptions>

            <div v-if="item.applyDetail && item.expandState">
              <el-table
                  :data="item.applyDetail.sealTradeDetailsInfo"
                  style="width: 100%">
                <el-table-column
                    prop="goodsName"
                    label="印章类型">
                </el-table-column>
                <el-table-column
                    prop="price"
                    label="价格">
                </el-table-column>
                <el-table-column
                    prop="quantity"
                    label="数量">
                </el-table-column>
              </el-table>
            </div>
            <!--        <div v-for="(ite, inde) in item.applyDetail.sealTradeDetailsInfo" :key="inde">-->
            <!--          <div>印章类型: {{ ite.goodsName ? ite.goodsName : '' }}</div>-->
            <!--        </div>-->
          </el-card>
        </div>

        <div v-else>
          <el-empty style="margin-top: 150px" description="暂无备案申请"></el-empty>
        </div>

        <div style="height: 100px"></div>

        <div class="bottom-box">
          <el-button type="primary" style="width: 40%" @click="type = 1">返回</el-button>
          <el-button type="primary" style="width: 40%" @click="refresh()">刷新</el-button>
        </div>
      </div>



      <div class="bottom-text" v-if="type == 0">
        <div class="">线上线下同步申请</div>
        <div class="">具备特行资质刻企承接制作</div>
<!--        安全可信 公安备案-->
      </div>
    </div>

    <div v-if="isWx || isAli" class="mask">
      <div class="arrow">
        <img src="@/assets/h5-openBrowser.png" style="width: 128px">
<!--        选择浏览器打开-->
      </div>
<!--      <div class="text">-->
<!--        <div class="box">-->
<!--          1、点击右上角<img src="@/assets/h5-wx.png">-->
<!--        </div>-->
<!--        <div class="box">-->
<!--          2、选择浏览器<img src="@/assets/h5-wx.png">-->
<!--        </div>-->
<!--      </div>-->
    </div>

  </div>

</template>

<script>

export default {
  name: "index",
  data() {
    var validIdCard = (rule, value, callback) => {
      let reg = /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/;
      if (value === "") {
        callback(new Error("请输入身份证号"));
      } else if (!reg.test(value) && !this.disbaleList) {
        callback(new Error("请输入正确的身份证号"));
      } else {
        callback();
      }
    };
    var validPhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入实名手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入实名手机号码"));
      } else {
        callback();
      }
    };
    return {
      isWx: /micromessenger/.test(window.navigator.userAgent.toLowerCase()),
      isAli: /AlipayClient/.test(window.navigator.userAgent),
      tableData: [],
      type: 0,

      ruleForm:{

      },
      loading: false,
      rules:{
        operatorName: [{required: true, message: "请输入经办人姓名", trigger: "blur"}],
        operatorId: [{required: true, validator: validIdCard, trigger: "blur"}],
        operatorPhone: [{required: true, validator: validPhone, trigger: "blur"}],
      },
    }
  },
  created(){
    this.type = 0
  },
  methods:{
    handleInputNumber(e){
      let value = this.ruleForm[e]
      this.$message.error(value.replace(/\D/g, ''))
      this.$set(this.ruleForm,e,value.replace(/\D/g, ''))
    },
    withdraw(index){
      this.$set(this.tableData[index] ,'expandState' ,false)
    },

    getDetail(tradeNo , index){
      this.$http.post(this.$api.H5.queryApplyDetail , {tradeNo: tradeNo}).then(res => {
        if (res.data.code == 200) {
          this.$set(this.tableData[index] ,'applyDetail' ,res.data.data.applyDetail)
          this.$set(this.tableData[index] ,'expandState' ,true)
        }
      })
    },

    refresh(){
      this.$http.post(this.$api.H5.queryApplyList , this.ruleForm).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.applyList;
          this.type = 2;
        }
      })
    },

    toAuth(){
      this.$router.push({
        path:'/h5/operatorAuthentication',
      })
    },

    getData(){
      this.$refs.ruleForm.validate((value) => {
        if (value) {
          this.$http.post(this.$api.H5.queryApplyList , this.ruleForm).then(res => {
            if (res.data.code == 200) {
              this.tableData = res.data.data.applyList;
              this.type = 2;
            }
          })
        }
      })

    }
  }
}
</script>

<style scoped lang="less">
.butt{
  width: 90%;
  height: 100px;
  margin-left: 5%;
  border-radius: 20px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);

  .box{
    border: 5px solid #ffffff;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    background: linear-gradient(to right, #007bff, #4ca1f1);
    font-size: 26px;
    font-weight: 900;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.bottom-box{
  width: 100%;
  height: 80px;
  position: fixed;
  bottom: 0;
  background-color: #FFFFFF;
  padding-top: 20px;
  z-index: 10;
}

::v-deep .el-form-item {
  padding: 10px 20px;
  margin-bottom: 0;
  box-sizing: border-box;
  border-bottom: 1px solid #ebedf0;
  background-color: #ffffff;
}

.input-item{
  padding: 10px 20px 18px 20px !important;
}

.mask{
  background-color: rgba(128, 128, 128, 1);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0px;
  z-index: 999;


  .arrow{
    z-index: 9999;
    position: absolute;
    right: 60px;
    top: 20px;
    display: flex;
    flex-direction: column;
  }

  .text{
    z-index: 9999;
    position: absolute;
    left: 40px;
    top: 20px;
    display: flex;
    flex-direction: column;
    align-content: center;
    color: #fff;
    font-size: 20px;

    .box{
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.header{
  height: 64px;
  background: linear-gradient(to right, #007bff, #4ca1f1, #007bff);
}

.bottom-text{
  position: absolute;
  bottom: 50px;
  color: #FFFFFF;
  text-align: center;
  width: 100%;
  padding: 0 10%;
  font-size: 18px;
}

.top-area {
  height: 100vh;
  //padding: 20px;
  box-sizing: border-box;
  background: url("../../../assets/home/bg.png") no-repeat;
  background-position: center center;
  background-size: cover;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.05);
}
</style>
